import React, { Dispatch } from 'react';
import { Pagination } from '@mui/material';
import { displayName } from '../../util';

interface ServerSidePaginationProps {
  currentPage: number;
  setCurrentPage: Dispatch<number>;
  totalNumberRows: number;
  maxSize: number;
}

export const ServerSidePagination: React.FC<ServerSidePaginationProps> = ({
  currentPage,
  setCurrentPage,
  totalNumberRows,
  maxSize,
}) => {
  const onChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setCurrentPage(newPage - 1);
  };

  return (
    <Pagination
      variant="outlined"
      color="primary"
      size="small"
      count={Math.ceil(totalNumberRows / maxSize)}
      page={currentPage + 1}
      onChange={onChange}
    />
  );
};

displayName(ServerSidePagination, 'ServerSidePagination');

export default ServerSidePagination;
